// extracted by mini-css-extract-plugin
export default {"contentWrapper":"TotalExpensesFormTable_contentWrapper__HZ0o1","loader":"TotalExpensesFormTable_loader__pIHev"};